import { Constants } from '@shared/utils/constants';
const fallbackCountryCode = 'US';
export const getLocaleLanguage = ({ locale })=>{
    const localeLanguage = (locale === null || locale === void 0 ? void 0 : locale.includes('-')) ? locale.split('-')[0] : Constants.DefaultLocale.split('-')[0];
    return localeLanguage;
};
function getCountryCodeRegion({ countryCode }) {
    const countryCodeRegion = countryCode ? countryCode.includes('-') ? countryCode.split('-')[1] : countryCode : fallbackCountryCode;
    return countryCodeRegion;
}
export function getLocale({ locale, countryCode }) {
    const localeLanguage = getLocaleLanguage({
        locale
    });
    const countryCodeRegion = getCountryCodeRegion({
        countryCode
    });
    const localeString = `${localeLanguage.toLowerCase()}-${countryCodeRegion.toUpperCase()}`;
    return localeString;
}
export function timeToLocalLocaleString({ timeUTCSeconds, locale, countryCode }) {
    const date = new Date(timeUTCSeconds * 1000);
    const localeString = getLocale({
        locale,
        countryCode
    });
    return date.toLocaleTimeString(localeString);
}
export function timeToLocalString({ timeUTCSeconds, locale, countryCode }) {
    const date = new Date(timeUTCSeconds * 1000);
    const localeString = getLocale({
        locale,
        countryCode
    });
    return date.toLocaleString(localeString);
}
export function numberToLocaleString({ number, locale, countryCode }) {
    const localeString = getLocale({
        locale,
        countryCode
    });
    return number.toLocaleString(localeString);
}
const catalogSupportedLocales = [
    'en',
    'cs',
    'de',
    'es',
    'fr',
    'hu',
    'it',
    'ja',
    'ko',
    'nl',
    'pl',
    'ru',
    'sv',
    'tr',
    'pt-br',
    'pt-pt',
    'zh-hans',
    'zh-hant'
];
const languageCodesThatShouldUseLocaleInstead = [
    'pt',
    'zh'
];
export const doesSearchSupportLanguage = ({ language })=>catalogSupportedLocales.indexOf(language) >= 0;
export const shouldUseLocaleInsteadOfLanguageCode = ({ language })=>languageCodesThatShouldUseLocaleInstead.indexOf(language) >= 0;
